export const SOCKET_FALLBACK_ORIGIN = 'https://localhost:5001';

export const socketOrigin = (apiUrl = process.env.REACT_APP_API_URL) => {
  if (typeof apiUrl !== 'string' || !apiUrl.trim()) return SOCKET_FALLBACK_ORIGIN;

  try {
    const parsed = new URL(apiUrl);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return SOCKET_FALLBACK_ORIGIN;
    return parsed.origin;
  } catch {
    return SOCKET_FALLBACK_ORIGIN;
  }
};
